import { plainToInstance } from "class-transformer";
export function safeAssign(target, source) {
    Object.assign(target, plainToInstance(Object.getPrototypeOf(target).constructor, source, {
        // Exclude properties not decorated with @Expose()
        excludeExtraneousValues: true,
        strategy: "exposeAll",
    }));
    return target;
}
//# sourceMappingURL=safe-assign.js.map